module.exports = __webpack_public_path__ + "img/ic-dropdown-arrow.02b9a52b.svg";